export const wageTypes: Array<{ label: string; value: string }> = [
    {
        label: 'کسر کارمزد از خودم',
        value: 'user',
    },
    {
        label: 'کسر کارمزد از مشتری',
        value: 'client',
    },
    {
        label: 'تقسیم کارمزد بین خودم و مشتری',
        value: 'between',
    },
    {
        label: 'کسر کارمزد از کیف پول',
        value: 'wallet',
    },
];

const statuses: Record<string, string> = {
    pending: 'در انتظار تایید',
    rejected: 'لغو شده',
    removed: 'حذف شده',
};

export const getStatusLabel = (status: string) => {
    return statuses[status] || '-';
};
